import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "../../utils/auth";
import { Container } from "react-bootstrap";

function Login() {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const result = await login(password);
      if (result.success) {
        // Redirect to home page after successful login
        navigate("/");
      } else {
        setError(result.error || "Invalid password");
      }
    } catch (err) {
      setError("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        marginTop: "-4rem",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "400px",
          padding: "2rem",
          borderRadius: "12px",
          boxShadow: "0 8px 24px rgba(240, 94, 255, 0.3)",
          backgroundColor: "rgba(20, 20, 20, 0.9)",
          border: "1px solid rgba(240, 94, 255, 0.2)",
        }}
      >
        <h2
          style={{
            color: "#f05eff",
            textAlign: "center",
            marginBottom: "2rem",
            fontSize: "2em",
          }}
        >
          Login
        </h2>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: "1.5rem" }}>
            <label
              htmlFor="password"
              style={{
                display: "block",
                color: "#f5a7ff",
                marginBottom: "0.5rem",
                fontSize: "1em",
              }}
            >
              Password
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{
                width: "100%",
                padding: "0.75rem",
                borderRadius: "8px",
                border: "1px solid rgba(240, 94, 255, 0.3)",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                color: "#fff",
                fontSize: "1em",
                outline: "none",
                transition: "border-color 0.3s ease, box-shadow 0.3s ease",
              }}
              onFocus={(e) => {
                e.target.style.borderColor = "#f05eff";
                e.target.style.boxShadow = "0 0 8px rgba(240, 94, 255, 0.3)";
              }}
              onBlur={(e) => {
                e.target.style.borderColor = "rgba(240, 94, 255, 0.3)";
                e.target.style.boxShadow = "none";
              }}
              required
              autoFocus
            />
          </div>
          {error && (
            <div
              style={{
                color: "#ff6b6b",
                marginBottom: "1rem",
                textAlign: "center",
                fontSize: "0.9em",
              }}
            >
              {error}
            </div>
          )}
          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%",
              padding: "0.75rem",
              borderRadius: "8px",
              border: "none",
              backgroundColor: loading ? "rgba(240, 94, 255, 0.5)" : "#f05eff",
              color: "#fff",
              fontSize: "1em",
              fontWeight: "bold",
              cursor: loading ? "not-allowed" : "pointer",
              transition: "background-color 0.3s ease, transform 0.2s ease",
              boxShadow: "0 4px 8px rgba(240, 94, 255, 0.3)",
            }}
            onMouseEnter={(e) => {
              if (!loading) {
                e.target.style.backgroundColor = "#e04de6";
                e.target.style.transform = "translateY(-2px)";
                e.target.style.boxShadow = "0 6px 12px rgba(240, 94, 255, 0.4)";
              }
            }}
            onMouseLeave={(e) => {
              if (!loading) {
                e.target.style.backgroundColor = "#f05eff";
                e.target.style.transform = "translateY(0)";
                e.target.style.boxShadow = "0 4px 8px rgba(240, 94, 255, 0.3)";
              }
            }}
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
      </div>
    </Container>
  );
}

export default Login;

